import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { Routes } from '../../core/routes/apiRoutes'
import demoRequestService from './requestDemoService'

const initialState = {
    data: null,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    errors: null,
}

//Create Demo Request
export const createDemoRequest = createAsyncThunk(Routes.createDemoRequestUrl, async (data, thunkAPI) => {
    try{
        return await demoRequestService.requestDemo(data);
    }catch (error) {
        var errorData = {message: (error.response && error.response.data && error.response.data.message) || error.message || error.toString()}
        if(error.response.status === 422){
            errorData['errors'] = error.response.data.errors;
            
        }
        return thunkAPI.rejectWithValue(errorData);
    }
})



export const demoRequestSlice = createSlice({
    name: 'demoRequest',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = '';
            state.errors = null;
            state.data = null;
        }
    }, 
    extraReducers: (builder) => {
        builder
        //Initialize Payment
        .addCase(createDemoRequest.pending, (state) => {
            state.isLoading = true
        })
        .addCase(createDemoRequest.fulfilled, (state,action) => {
            state.isLoading = false
            state.isSuccess = true
            state.isError = false
            state.data = action.payload
            state.errors = null

        })
        .addCase(createDemoRequest.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload.message
            state.errors = action.payload.errors
        })
    }
})

export const {reset} = demoRequestSlice.actions
export default demoRequestSlice.reducer